(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
      $(document).ready(function(){

        var arr = [],
            count_select = $('#shopify-section-filters select').length;
        $('#SortTags option').each(function () {
          arr.push($(this).val());
        });

        $('#shopify-section-filters select').each(function(){
          var originalElems = $(this),
              filterName = originalElems.find('option:first').text(),
              elems = originalElems.find('option'),
              count = elems.length,
              currSelect;

          elems.each(function(){
            if ($.inArray($(this).val(), arr) == -1 && $(this).val() != '') {
              $(this).remove();
            };
            if (!--count) {
              if(originalElems.find('option').length > 2) {
                $('.filters-toolbar').append('<div class="col-lg-12 pull-lg-12 col-md-30">' + originalElems.parent('.filter_holder').html() + '</div>');
              }
            }
          });

          if(!--count_select) {
            setTimeout(function(){
              $('.custom-select:visible').each(function() {
                var classes = $(this).attr("class"),
                    id      = $(this).attr("id"),
                    name    = $(this).attr("name");
                var template =  '<div class="' + classes + '">';
                    template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
                    template += '<div class="custom-options">';
                    $(this).find("option").each(function() {
                      if($(this).val() != '') {
                        var new_class = '';
                        if($(this).is(':selected')) {
                          new_class = ' selection';
                        }
                        template += '<span class="custom-option ' + $(this).attr("class") + new_class + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
                      } else {
                        template += '<span class="custom-option ' + $(this).attr("class") + new_class + '" data-value="' + $(this).attr("value") + '">All ' + $(this).html() + 's</span>';
                      }
                    });
                template += '</div></div>';

                $(this).wrap('<div class="custom-select-wrapper"></div>');
                $(this).hide();
                $(this).after(template);
              });
            },500);
          }
        });

        function getSizedImageUrl(src, size) {
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return prefix[0] + '_' + size + suffix;
          }
          return null;
        }
        $('.swatch-element.color:not(.morecolors)').on('click',function(){
          var var_id = $(this).data('varid'),
              sec_id = $(this).closest('.grid-view-item').data('sectionid'),
              featured_img = $(this).closest('.grid-view-item').find('.grid-view-item__image'),
              json = JSON.parse(document.getElementById('ProductJson-' + sec_id).innerHTML),
              prod_vars = json.variants;
          for(i = 0; i < prod_vars.length; ++i){
            if(var_id == prod_vars[i].id) {
              var curr_fi = prod_vars[i].featured_image;
              if(curr_fi !== null) {
                var image = getSizedImageUrl(curr_fi.src, '650x550');
                $(featured_img).css('background-image','url(' + image + ')');
              }
            }
          }
        });


        $(".custom-option:first-of-type").hover(function() {
          $(this).parents(".custom-options").addClass("option-hover");
        }, function() {
          $(this).parents(".custom-options").removeClass("option-hover");
        });
        $('body').on('click','.custom-select-trigger', function() {
          $(".custom-select").not($(this).parents(".custom-select")).removeClass("opened");
          $(this).parents(".custom-select").toggleClass("opened");
          event.stopPropagation();
        });
        $('body').on('click','.custom-option', function() {
          $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value")).trigger('change');
          $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
          $(this).addClass("selection");
          $(this).parents(".custom-select").removeClass("opened");
          $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
        });

      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  (function(){
    var d = document,
    accordionToggles = d.querySelectorAll('.js-accordionTrigger'),
    setAria,
    setAccordionAria,
    switchAccordion,
    touchSupported = ('ontouchstart' in window),
    pointerSupported = ('pointerdown' in window);

    skipClickDelay = function(e){
      e.preventDefault();
      e.target.click();
    }

      setAriaAttr = function(el, ariaType, newProperty){
      el.setAttribute(ariaType, newProperty);
    };
    setAccordionAria = function(el1, el2, expanded){
      switch(expanded) {
        case "true":
          setAriaAttr(el1, 'aria-expanded', 'true');
          setAriaAttr(el2, 'aria-hidden', 'false');
          break;
        case "false":
          setAriaAttr(el1, 'aria-expanded', 'false');
          setAriaAttr(el2, 'aria-hidden', 'true');
          break;
        default:
          break;
      }
    };

    switchAccordion = function(e) {
      e.preventDefault();
      var thisAnswer = e.target.parentNode.nextElementSibling;
      var thisQuestion = e.target;
      if(thisAnswer.classList.contains('is-collapsed')) {
        setAccordionAria(thisQuestion, thisAnswer, 'true');
      } else {
        setAccordionAria(thisQuestion, thisAnswer, 'false');
      }
      thisQuestion.classList.toggle('is-collapsed');
      thisQuestion.classList.toggle('is-expanded');
      thisAnswer.classList.toggle('is-collapsed');
      thisAnswer.classList.toggle('is-expanded');

      thisAnswer.classList.toggle('animateIn');
    };
    for (var i=0,len=accordionToggles.length; i<len; i++) {
      if(touchSupported) {
        accordionToggles[i].addEventListener('touchstart', skipClickDelay, false);
      }
      if(pointerSupported){
        accordionToggles[i].addEventListener('pointerdown', skipClickDelay, false);
      }
      accordionToggles[i].addEventListener('click', switchAccordion, false);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bottom"]) return;
  try {
    
  $(document).ready(function(){
    $('.products-related').slick({
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
      customPaging : function(slider, i) {
        var tabtype = $(slider.$slides[i]).data('tabtype');
        return '<a class="btn btn--secondary">'+tabtype+'</a>';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-collection-template"]) return;
  try {
    
      $(document).ready(function(){

        var arr = [],
            count_select = $('#shopify-section-filters select').length;
        $('#SortTags option').each(function () {
          arr.push($(this).val());
        });

        $('#shopify-section-filters select').each(function(){
          var originalElems = $(this),
              filterName = originalElems.find('option:first').text(),
              elems = originalElems.find('option'),
              count = elems.length,
              currSelect;

          elems.each(function(){
            if ($.inArray($(this).val(), arr) == -1 && $(this).val() != '') {
              $(this).remove();
            };
            if (!--count) {
              if(originalElems.find('option').length > 2) {
                $('.filters-toolbar').append('<div class="col-lg-12 pull-lg-12 col-md-30">' + originalElems.parent('.filter_holder').html() + '</div>');
              }
            }
          });

          if(!--count_select) {
            setTimeout(function(){
              $('.custom-select:visible').each(function() {
                var classes = $(this).attr("class"),
                    id      = $(this).attr("id"),
                    name    = $(this).attr("name");
                var template =  '<div class="' + classes + '">';
                    template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
                    template += '<div class="custom-options">';
                    $(this).find("option").each(function() {
                      if($(this).val() != '') {
                        var new_class = '';
                        if($(this).is(':selected')) {
                          new_class = ' selection';
                        }
                        template += '<span class="custom-option ' + $(this).attr("class") + new_class + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
                      } else {
                        template += '<span class="custom-option ' + $(this).attr("class") + new_class + '" data-value="' + $(this).attr("value") + '">All ' + $(this).html() + 's</span>';
                      }
                    });
                template += '</div></div>';

                $(this).wrap('<div class="custom-select-wrapper"></div>');
                $(this).hide();
                $(this).after(template);
              });
            },500);
          }
        });

        function getSizedImageUrl(src, size) {
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (match != null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return prefix[0] + '_' + size + suffix;
          }
          return null;
        }
        $('.swatch-element.color:not(.morecolors)').on('click',function(){
          var var_id = $(this).data('varid'),
              sec_id = $(this).closest('.grid-view-item').data('sectionid'),
              featured_img = $(this).closest('.grid-view-item').find('.grid-view-item__image'),
              json = JSON.parse(document.getElementById('ProductJson-' + sec_id).innerHTML),
              prod_vars = json.variants;
          for(i = 0; i < prod_vars.length; ++i){
            if(var_id == prod_vars[i].id) {
              var curr_fi = prod_vars[i].featured_image;
              if(curr_fi !== null) {
                var image = getSizedImageUrl(curr_fi.src, '650x550');
                $(featured_img).css('background-image','url(' + image + ')');
              }
            }
          }
        });


        $(".custom-option:first-of-type").hover(function() {
          $(this).parents(".custom-options").addClass("option-hover");
        }, function() {
          $(this).parents(".custom-options").removeClass("option-hover");
        });
        $('body').on('click','.custom-select-trigger', function() {
          $(".custom-select").not($(this).parents(".custom-select")).removeClass("opened");
          $(this).parents(".custom-select").toggleClass("opened");
          event.stopPropagation();
        });
        $('body').on('click','.custom-option', function() {
          $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value")).trigger('change');
          $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
          $(this).addClass("selection");
          $(this).parents(".custom-select").removeClass("opened");
          $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
        });

      });

  } catch(e) { console.error(e); }
})();
})();
